var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 41,
    viewBox: "0 0 29 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1H1V2V37V38.9522L2.5843 37.8115L14.5 29.2322L26.4157 37.8115L28 38.9522V37V2V1H27H2Z",
    fill: "#F28986",
    stroke: "#404040",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5413 15.1977L14.7838 8.09069C14.6346 7.96977 14.3655 7.96977 14.2162 8.09069L5.4589 15.1975C4.8471 15.6934 4.8471 16.5005 5.45851 16.9961C5.75782 17.2392 6.15696 17.3736 6.58209 17.3736C6.86589 17.3736 7.13515 17.3088 7.37378 17.1968V22.6874C7.37378 22.8603 7.55116 23 7.76963 23H12.5202C12.7389 23 12.916 22.8603 12.916 22.6874V18.6238H16.0832V22.6874C16.0832 22.8603 16.2602 23 16.4791 23H21.2298C21.4487 23 21.6257 22.8603 21.6257 22.6874V17.1968C21.8645 17.3088 22.1336 17.3736 22.4174 17.3736C22.8427 17.3736 23.2416 17.2392 23.541 16.9961C24.153 16.5005 24.153 15.6934 23.5413 15.1977ZM16.8753 22.3749V18.3113C16.8753 18.1384 16.6983 17.9987 16.4795 17.9987H12.5206C12.3019 17.9987 12.1247 18.1384 12.1247 18.3113V22.3749H8.16587V16.6233L14.5 11.4832L20.8344 16.6233V22.3749H16.8753ZM22.9737 16.5604C22.6754 16.8028 22.1599 16.8028 21.8616 16.5604L14.7838 10.8169C14.7092 10.7564 14.6068 10.7223 14.5 10.7223C14.3932 10.7223 14.2909 10.7564 14.2162 10.8169L7.13864 16.5602C6.8401 16.8027 6.32504 16.803 6.02611 16.5602C5.7111 16.3048 5.7111 15.8889 6.02631 15.6334L14.5 8.75682L22.9737 15.6337C23.2893 15.889 23.2893 16.3049 22.9737 16.5604Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTag);
export default __webpack_public_path__ + "static/media/home_tag.64887dc6e446021ae59c3111aab21285.svg";
export { ForwardRef as ReactComponent };